/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddCrmProjectNoteInput
 */
export interface AddCrmProjectNoteInput {
    /**
     * 
     * @type {string}
     * @memberof AddCrmProjectNoteInput
     */
    body?: string;
}

/**
 * Check if a given object implements the AddCrmProjectNoteInput interface.
 */
export function instanceOfAddCrmProjectNoteInput(value: object): value is AddCrmProjectNoteInput {
    return true;
}

export function AddCrmProjectNoteInputFromJSON(json: any): AddCrmProjectNoteInput {
    return AddCrmProjectNoteInputFromJSONTyped(json, false);
}

export function AddCrmProjectNoteInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddCrmProjectNoteInput {
    if (json == null) {
        return json;
    }
    return {
        
        'body': json['body'] == null ? undefined : json['body'],
    };
}

export function AddCrmProjectNoteInputToJSON(json: any): AddCrmProjectNoteInput {
    return AddCrmProjectNoteInputToJSONTyped(json, false);
}

export function AddCrmProjectNoteInputToJSONTyped(value?: AddCrmProjectNoteInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': value['body'],
    };
}

